export default {
  date: {
    y: "ปี",
    m: "เดือน",
    d: "วัน",
  },

  time: {
    h: "ชั่วโมง",
    min: "นาที่",
    s: "วินาที",
    ago: "ที่เเล้ว",
    present: "ปัจจุบัน",
    justNow: "เมื่อสักครู่",
  },

  //ไม่มีข้อมูล
  noData: "ไม่มีข้อมูล",
  //ไม่ระบุ
  notSpecified: "ไม่ระบุ",

  // ตรวจสอบเอกสาร
  checkDocs: {
    code_0: "Digital signature และ XML ไม่น่าเชื่อถือ",
    code_1: "Digital signature น่าเชื่อถือ แต่ XML ไม่น่าเชื่อถือ",
    code_2: "Digital signature และ XML น่าเชื่อถือ",
  },
};
